import React from 'react'

function ErrorHandler() {
  return <></>
}

export default ErrorHandler
